import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "grid gap-5 text-left md:grid-cols-[minmax(0,1fr)_340px] md:items-start",
  "data-testid": "send-record-step-5"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex flex-col gap-y-3" }
const _hoisted_4 = { class: "rounded-lg border border-lightGray30 divide-y divide-gray-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 px-3 py-2" }, [
  /*#__PURE__*/_createElementVNode("dt", { class: "w-28 text-xs text-neutral50" }, "Categoria"),
  /*#__PURE__*/_createElementVNode("dd", { class: "flex-1 text-sm text-textPrimary" }, "Registro de Atividade · Jornada")
], -1)
const _hoisted_6 = { class: "flex gap-3 px-3 py-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", { class: "w-28 text-xs text-neutral50" }, "Tipo", -1)
const _hoisted_8 = {
  class: "flex-1 text-sm text-textPrimary",
  "data-testid": "send-record-review-type"
}
const _hoisted_9 = {
  key: 0,
  class: "flex gap-3 px-3 py-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", { class: "w-28 text-xs text-neutral50" }, "Descrição", -1)
const _hoisted_11 = { class: "flex-1 text-sm text-textPrimary" }
const _hoisted_12 = { class: "flex gap-3 px-3 py-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", { class: "w-28 text-xs text-neutral50" }, "Médico", -1)
const _hoisted_14 = { class: "flex-1 text-sm text-textPrimary" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 px-3 py-2" }, [
  /*#__PURE__*/_createElementVNode("dt", { class: "w-28 text-xs text-neutral50" }, "Vai para"),
  /*#__PURE__*/_createElementVNode("dd", { class: "flex-1 text-sm text-textPrimary" }, " Fila de auditoria — filtro Registro de Atividade ")
], -1)
const _hoisted_16 = { class: "text-sm font-bold text-textPrimary" }
const _hoisted_17 = ["data-testid"]
const _hoisted_18 = { class: "flex flex-wrap items-center justify-between gap-2" }
const _hoisted_19 = { class: "text-[13px] font-bold text-textPrimary" }
const _hoisted_20 = { class: "inline-flex flex-none items-center rounded-full bg-primary5 px-2 py-[3px] text-[11.5px] font-bold text-primary40" }
const _hoisted_21 = { class: "mt-2 grid grid-cols-2 gap-3" }
const _hoisted_22 = { class: "text-[12.5px] font-bold text-neutral50" }
const _hoisted_23 = { class: "text-[22px] font-bold tabular-nums text-textPrimary" }
const _hoisted_24 = { class: "text-[11.5px] text-neutral50" }
const _hoisted_25 = {
  key: 0,
  class: "rounded border border-yellow-200 bg-yellow-50 px-3 py-2 text-xs text-yellow-900",
  "data-testid": "send-record-review-warnings"
}
const _hoisted_26 = { class: "flex items-start gap-2 text-sm text-textPrimary cursor-pointer" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Declaro que as informações e os anexos enviados são verdadeiros e correspondem ao atendimento realizado nos plantões acima. "),
  /*#__PURE__*/_createElementVNode("span", { class: "block text-xs text-neutral50" }, " Sua declaração fica registrada com seu nome, data e hora. ")
], -1)
const _hoisted_29 = {
  key: 1,
  class: "rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800",
  "data-testid": "send-record-error"
}
const _hoisted_30 = {
  key: 1,
  class: "flex flex-col gap-2"
}
const _hoisted_31 = { class: "rounded-[10px] border border-lightGray30 px-3 py-2 text-xs text-neutral50" }
const _hoisted_32 = { class: "font-bold text-textPrimary" }
const _hoisted_33 = {
  key: 0,
  class: "font-normal"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 1,
  class: "mt-1"
}

import { computed } from 'vue'
import {
  ACTIVITY_TYPE_LABELS,
  COVERED_LEGS_LABELS,
  CoveredLegs
} from '@/constants/ds-attendance.constants'
import type { ActivityType } from '@/constants/ds-attendance.constants'
import { DESKTOP_MEDIA_QUERY, useMediaQuery } from '@/hooks/useMediaQuery'
import AttachmentPanel from './AttachmentPanel.vue'
import {
  ACTIVITY_ERROR_WITH_QUEUE_LINK,
  buildToleranceWarnings,
  formatFileSize,
  isoToTimeInput,
  minutesBetween,
  type NormalizedPrefillItem,
  type SendRecordLine
} from './types'

/** Passo 5 de M2 — resumo, declaração de veracidade e envio. */


export default /*#__PURE__*/_defineComponent({
  __name: 'StepReview',
  props: {
    activityType: {},
    description: {},
    files: {},
    lines: {},
    prefill: {},
    toleranceTexts: {},
    doctorLine: {},
    truthDeclaration: { type: Boolean },
    errorCode: {},
    errorMessage: {},
    activeIndex: {}
  },
  emits: ["update:truthDeclaration", "update:activeIndex", "open-queue"],
  setup(__props: any, { emit }) {

const props = __props;





/** Só o painel do layout atual é montado — ver o comentário do `v-if` no template. */
const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY)

const activityTypeLabel = computed(() =>
  props.activityType ? ACTIVITY_TYPE_LABELS[props.activityType] : '—'
)

const totalBytes = computed(() => props.files.reduce((sum, file) => sum + file.size, 0))

const prefillById = computed(
  () => new Map(props.prefill.map((item) => [item.doctorStationId, item]))
)

function covers(line: SendRecordLine, leg: CoveredLegs): boolean {
  return line.coveredLegs === leg || line.coveredLegs === CoveredLegs.BOTH
}

/**
 * As duas pernas lado a lado: o declarado em destaque, o previsto embaixo e a
 * diferença em minutos quando há uma — verde dentro da tolerância, amarelo fora
 * (a mesma régua do passo 4, via `buildToleranceWarnings`).
 */
function reviewLegsOf(line: SendRecordLine) {
  const item = prefillById.value.get(line.doctorStationId)
  const warnings = buildToleranceWarnings({
    line,
    expectedStart: item?.expectedStart ?? null,
    expectedEnd: item?.expectedEnd ?? null,
    checkinLateToleranceMinutes: item?.checkinLateToleranceMinutes ?? null,
    checkoutEarlyToleranceMinutes: item?.checkoutEarlyToleranceMinutes ?? null
  })

  return [
    {
      key: 'checkin',
      label: 'Check-in',
      ...legFacts({
        covered: covers(line, CoveredLegs.CHECKIN),
        declared: line.declaredCheckin,
        expected: item?.expectedStart ?? null,
        minutes: minutesBetween(item?.expectedStart ?? null, line.declaredCheckin),
        offset: line.timezone,
        outOfTolerance: warnings.some((warning) => warning.leg === 'CHECKIN')
      })
    },
    {
      key: 'checkout',
      label: 'Check-out',
      ...legFacts({
        covered: covers(line, CoveredLegs.CHECKOUT),
        declared: line.declaredCheckout,
        expected: item?.expectedEnd ?? null,
        minutes: minutesBetween(line.declaredCheckout, item?.expectedEnd ?? null),
        offset: line.timezone,
        outOfTolerance: warnings.some((warning) => warning.leg === 'CHECKOUT')
      })
    }
  ]
}

function legFacts(params: {
  covered: boolean
  declared: string | null
  expected: string | null
  minutes: number | null
  offset: string
  outOfTolerance: boolean
}) {
  if (!params.covered) {
    return { declared: '—', expected: 'fica como o sistema tem', diff: '', diffClass: '' }
  }

  const expected = isoToTimeInput(params.expected, params.offset)
  const difference = params.minutes ?? 0
  return {
    declared: isoToTimeInput(params.declared, params.offset) || '—',
    expected: expected ? `previsto ${expected}` : 'sem previsto',
    diff: difference
      ? `${Math.abs(difference)} min ${params.outOfTolerance ? 'fora da tolerância' : 'dentro da tolerância'}`
      : '',
    diffClass: params.outOfTolerance ? 'text-[#8A6A00]' : 'text-sucess'
  }
}

function describe(line: SendRecordLine): string {
  const item = prefillById.value.get(line.doctorStationId)
  const date = formatDate(item?.expectedStart)
  const legs = COVERED_LEGS_LABELS[line.coveredLegs]
  const times = [
    isoToTimeInput(line.declaredCheckin, line.timezone) || null,
    isoToTimeInput(line.declaredCheckout, line.timezone) || null
  ]
    .filter(Boolean)
    .join('–')
  return [date, legs, times].filter(Boolean).join(' · ')
}

function formatDate(value?: string | null): string {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleDateString('pt-BR')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.files.length && !_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AttachmentPanel, {
            layout: "carousel",
            files: _ctx.files,
            "active-index": _ctx.activeIndex,
            "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => (emit('update:activeIndex', $event)))
          }, null, 8, ["files", "active-index"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("dl", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("dd", _hoisted_8, _toDisplayString(activityTypeLabel.value), 1)
        ]),
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("dd", _hoisted_11, _toDisplayString(_ctx.description), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("dd", _hoisted_14, _toDisplayString(_ctx.doctorLine), 1)
        ]),
        _hoisted_15
      ]),
      _createElementVNode("p", _hoisted_16, "Plantões (" + _toDisplayString(_ctx.lines.length) + ")", 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line) => {
        return (_openBlock(), _createElementBlock("div", {
          key: line.doctorStationId,
          class: "rounded-[10px] border border-lightGray30 px-3 py-2.5",
          "data-testid": `send-record-review-line-${line.doctorStationId}`
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(describe(line)), 1),
            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(COVERED_LEGS_LABELS)[line.coveredLegs]), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviewLegsOf(line), (leg) => {
              return (_openBlock(), _createElementBlock("div", {
                key: leg.key
              }, [
                _createElementVNode("p", _hoisted_22, _toDisplayString(leg.label), 1),
                _createElementVNode("p", _hoisted_23, _toDisplayString(leg.declared), 1),
                _createElementVNode("p", _hoisted_24, _toDisplayString(leg.expected), 1),
                (leg.diff)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["text-[11.5px]", leg.diffClass])
                    }, _toDisplayString(leg.diff), 3))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ], 8, _hoisted_17))
      }), 128)),
      (_ctx.toleranceTexts.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toleranceTexts, (text) => {
              return (_openBlock(), _createElementBlock("li", { key: text }, _toDisplayString(text), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("label", _hoisted_26, [
        _createElementVNode("input", {
          type: "checkbox",
          class: "mt-1",
          checked: _ctx.truthDeclaration,
          "data-testid": "send-record-truth-declaration",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('update:truthDeclaration', ($event.target as HTMLInputElement).checked)))
        }, null, 40, _hoisted_27),
        _hoisted_28
      ]),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1),
            (_ctx.errorCode === _unref(ACTIVITY_ERROR_WITH_QUEUE_LINK))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "mt-1 text-xs underline font-bold",
                  "data-testid": "send-record-open-queue-link",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('open-queue')))
                }, " Ver na fila "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createVNode(AttachmentPanel, {
            layout: "side",
            files: _ctx.files,
            "active-index": _ctx.activeIndex,
            "onUpdate:activeIndex": _cache[3] || (_cache[3] = ($event: any) => (emit('update:activeIndex', $event)))
          }, null, 8, ["files", "active-index"]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("p", _hoisted_32, [
              _createTextVNode(" Anexos "),
              (_ctx.files.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, " · " + _toDisplayString(_ctx.files.length) + " " + _toDisplayString(_ctx.files.length === 1 ? 'arquivo' : 'arquivos') + " · " + _toDisplayString(_unref(formatFileSize)(totalBytes.value)), 1))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
              return (_openBlock(), _createElementBlock("p", {
                key: file.name,
                class: "mt-0.5 truncate"
              }, _toDisplayString(file.name) + " · " + _toDisplayString(_unref(formatFileSize)(file.size)), 1))
            }), 128)),
            (!_ctx.files.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_34, "Nenhum anexo"))
              : (_ctx.lines.length > 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_35, " compartilhados pelos " + _toDisplayString(_ctx.lines.length) + " registros ", 1))
                : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})